import React, { FC, useMemo, useState } from "react"

import { Select, SelectProps } from "@mantine/core"
import { IconLanguage } from "@tabler/icons-react"

import LanguageSelectItem from "./LanguageSelectItem"
import { LanguageCode, languages, useLanguage } from "../../../contexts/language-context"

type LanguageSelectProps = Omit<SelectProps, "data"> & { value?: LanguageCode }

const LanguageSelect: FC<LanguageSelectProps> = ({ value, onChange, ...props }) => {
    const [_value, set_value] = useState<LanguageCode | undefined>(value ?? undefined)
    const { L } = useLanguage()
    const Icon = useMemo(() => {
        const Flag = _value ? languages[_value].Flag : null
        if (Flag) return <Flag w={20} radius="xs" />
        else return <IconLanguage size={16} />
    }, [_value])

    const _onChange = (value: LanguageCode) => {
        set_value(value)
        onChange?.(value)
    }

    return (
        <Select
            data={Object.entries(languages).map(([value, language]) => ({ value, ...language }))}
            itemComponent={LanguageSelectItem}
            placeholder={L("Language")}
            icon={Icon}
            searchable
            {...props}
            onChange={_onChange}
            value={_value}
        />
    )
}

export default LanguageSelect
